import { useMemo } from 'react';

var useProps = function (_props, keys) {
    var state = useMemo(function () {
        var props = {};
        var rest = {};
        for (var _i = 0, _a = Object.keys(_props); _i < _a.length; _i++) {
            var key = _a[_i];
            if (keys.includes(key)) {
                props[key] = _props[key];
            }
            else {
                rest[key] = _props[key];
            }
        }
        return { props: props, rest: rest };
    }, [_props]);
    return state;
};

export { useProps as default };
